var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImprove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 125.896,
    height: 130.3,
    viewBox: "0 0 125.896 130.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.194,
    y1: 0.21,
    x2: 1.461,
    y2: 1.187,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#55a4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55a4ff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_7650",
    x: 50.475,
    y: 22.831,
    width: 75.421,
    height: 107.469,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#07111a"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_7649",
    x: 33.65,
    y: 31.644,
    width: 75.421,
    height: 98.656,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#07111a"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_7648",
    x: 16.825,
    y: 41.259,
    width: 75.421,
    height: 89.042,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#07111a"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_7647",
    x: 0,
    y: 48.469,
    width: 75.421,
    height: 81.831,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#07111a"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_62700",
    x: 1.745,
    y: 5.092,
    width: 116.911,
    height: 91.637,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#07111a"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_62701",
    x: 45.59,
    y: 0,
    width: 75.662,
    height: 78.16,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#07111a"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29917",
    "data-name": "Group 29917",
    transform: "translate(-66.5 5.992)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 69.5, -5.99)",
    filter: "url(#Rectangle_7650)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7650-2",
    "data-name": "Rectangle 7650",
    width: 14.421,
    height: 46.469,
    rx: 3,
    transform: "translate(75.97 48.33)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 69.5, -5.99)",
    filter: "url(#Rectangle_7649)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7649-2",
    "data-name": "Rectangle 7649",
    width: 14.421,
    height: 37.656,
    rx: 3,
    transform: "translate(59.15 57.14)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 69.5, -5.99)",
    filter: "url(#Rectangle_7648)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7648-2",
    "data-name": "Rectangle 7648",
    width: 14.421,
    height: 28.042,
    rx: 3,
    transform: "translate(42.32 66.76)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 69.5, -5.99)",
    filter: "url(#Rectangle_7647)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7647-2",
    "data-name": "Rectangle 7647",
    width: 14.421,
    height: 20.831,
    rx: 3,
    transform: "translate(25.5 73.97)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-arrow-right",
    "data-name": "Icon feather-arrow-right",
    transform: "matrix(0.891, -0.454, 0.454, 0.891, 108.983, 42.443)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.89, 0.45, -0.45, 0.89, -13.19, -61.08)",
    filter: "url(#Path_62700)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62700-2",
    "data-name": "Path 62700",
    d: "M0,0H57.835",
    transform: "matrix(0.89, -0.45, 0.45, 0.89, 29.44, 59.04)",
    fill: "none",
    stroke: "#55a4ff",
    strokeLinecap: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.89, 0.45, -0.45, 0.89, -13.19, -61.08)",
    filter: "url(#Path_62701)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62701-2",
    "data-name": "Path 62701",
    d: "M0,0,4.887,4.887,0,9.774",
    transform: "matrix(0.89, -0.45, 0.45, 0.89, 74.39, 30.65)",
    fill: "none",
    stroke: "#55a4ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImprove);
export default __webpack_public_path__ + "static/media/improve.fde8c9faf34833f839fa2d5a81756a24.svg";
export { ForwardRef as ReactComponent };